import { Injectable } from '@angular/core';
import { IsoDate, PlanView } from 'src/app/admin/pages/plan-management/data/plan-management.models';

/**
 * The plans the user chose for new inspections, one per region and inspection type: in
 * the Plan Assistant, or when asked before inserting on a day two open plans hold. Every
 * inspection save sends them, and the server uses one only for a new inspection on a day
 * several plans hold and only if it is one of them, so a choice that no longer applies is
 * harmless. It has no dependencies, so the save API can read it.
 */
@Injectable({ providedIn: 'root' })
export class InsertionPlanChoiceState {
  private readonly chosen = new Map<string, PlanView>();

  choose(plan: PlanView): void {
    this.chosen.set(choiceKey(plan.RegionId, plan.ExactInterventionIdentity), plan);
  }

  clear(): void {
    this.chosen.clear();
  }

  /** The plan chosen for the region and type, while its window holds the day. */
  chosenFor(regionId: string, inspectionTypeId: string, day: IsoDate): PlanView | null {
    const plan = this.chosen.get(choiceKey(regionId, inspectionTypeId));
    return plan && plan.WindowStart <= day && day <= plan.WindowEnd ? plan : null;
  }

  preferredPlanIds(): string[] {
    return [...this.chosen.values()].map(plan => plan.PlanId);
  }
}

function choiceKey(regionId: string, inspectionTypeId: string): string {
  return `${regionId}|${inspectionTypeId}`;
}
